import { IncomingMessage } from 'http'

export function isGoogleBotAgent(req: IncomingMessage) {
  return (req.headers['user-agent'] || '').includes('Googlebot')
}
